const damageColorObject = {
  4: 'bg-lime-500',
  2: 'bg-lime-600',
  1: 'bg-white',
  0: 'bg-zinc-800',
  0.5: 'bg-red-700',
  0.25: 'bg-red-900'
}

export default damageColorObject;